import { Icon } from './Icon';
import { BpIcon } from './BpIcon';
import { BoxIcon } from './BoxIcon';
import { FaIcon } from './FaIcon';


Icon.Bp = BpIcon;
Icon.Fa = FaIcon;
Icon.Box = BoxIcon;
export { Icon };
